let saved_items;
var add_to_cart = $("#add-to-cart")
groupObj = {},
  add_to_group = $("#add-to-group"),
  update_group_order_btn = $('#update-group-order');

function GetURLParameter(sParam)
  {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++)
    {
      var sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] == sParam)
      {
        return sParameterName[1];
      }
    }
  }

function group_get_cart_api(){
  return fetch('/cart.js', {
    method: 'GET',
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
    return data;
  })
}

$('.product-form').change(function(){
  console.log('change');
});

function group_set_items_to_member(item){
  axios.post('https://bridge.toxicfox.co.uk/api/groups/'+getCookie('current_group_uuid')+'/members/'+getCookie('current_member_uuid')+'/item', {
    item: item,
    objKey: item.key,
    headers: {
      "Access-Control-Allow-Origin": "*"
    }
  })
  .then(function (response) {
    let data = response.data;
    console.log(data);
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  });

}

async function push_to_group(){
  let add_to_group_btn = $('#add_to_group_btn');
  add_to_group_btn.prop('disabled', true);

  var g_cart = await group_get_cart_api();

  for (var i = 0; i < g_cart.items.length; i++) {
    var item = g_cart.items[i];
    group_set_items_to_member(item);
  }

  setTimeout(
    function() 
    {
      window.location.href= 'https://www.toxicfox.co.uk/pages/groups?group='+getCookie('current_group_uuid');
      add_to_group_btn.prop('disabled', false);
    }, 1000);

}

var imgPreview = $("img#character-preview");

if(imgPreview.length > 0){

  var imgPreview = document.querySelector("img#character-preview");
  
  $('img#character-preview').prop('src').change(function(){
  	add_to_group.prop('disabled', false);
  });

  var observer = new MutationObserver((changes) => {
    changes.forEach(change => {
      if(change.attributeName.includes('src')){
        //console.dir(img.src);
        if(imgPreview.prop('src') != 'https://moonshine-live.midnightplatform.net/myswag_ghost.png'){
          add_to_group.prop('disabled', false);
        }
      }w
    });
  });

  observer.observe(imgPreview, {attributes : true});

}

// $('.product-form').change(function(){
//  add_to_group.prop('disabled', false);
// });

function add_to_group_order(){

  var $myForm = $('.product-form');

  if(! $myForm[0].checkValidity()) {
    // If the form is invalid, submit it. The form won't actually submit;
    // this will just cause the browser to display the native HTML5 error messages.
    $myForm.find(':submit').click();
  }else{

    let array = $('.product-form').serializeArray();

    Swal.fire({
      title: 'Add to '+groupObj.name+' Order?',
      text: 'This product will be added to the group order',
      icon: 'question',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post('https://bridge.toxicfox.co.uk/api/groups/'+getCookie('current_group_uuid')+'/members/'+getCookie('current_member_uuid')+'/items', {
          data: array,
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(function (response) {
          let data = response.data;
          Swal.fire({
            title: 'Your Item is Ready',
            text: 'Your product will be added to '+groupObj.name+' order',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Submit Product for Approval',
            cancelButtonText: 'Add another product?',
          }).then((result) => {
            if (result.isConfirmed) {
              drop_group(false);
            }
          });
          //return false;
          //delete_cookie('current_group_uuid', getCookie('current_group_uuid'), 30);
          //delete_cookie('current_member_uuid', getCookie('current_member_uuid'), 30);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      }
    })

  }
}

function update_group_order(){

  var product_form = $('.product-form');

  let array = product_form.serializeArray();

    Swal.fire({
      title: 'Update this item?',
      text: 'This item in '+groupObj.name+' group order will be updated',
      icon: 'question',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.put('https://bridge.toxicfox.co.uk/api/groups/'+getCookie('current_group_uuid')+'/members/'+getCookie('current_member_uuid')+'/item/'+GetURLParameter('item_id'), {
          data: array,
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(function (response) {
          let data = response.data;
          Swal.fire({
            title: 'Updated Item',
            text: 'This item was updated in '+groupObj.name+'\'s order, it will need to be approved by an admin.',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Completed',
          }).then((result) => {
            if (result.isConfirmed) {
              drop_group(false);
            }
          });
          //return false;
          //delete_cookie('current_group_uuid', getCookie('current_group_uuid'), 30);
          //delete_cookie('current_member_uuid', getCookie('current_member_uuid'), 30);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      }
    })
}

function delete_cookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT";
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}



//    $('.product-form').submit(function(e){

//      if(getCookie('current_group_uuid')) {

//        let array = $(this).serializeArray();

//        console.log(array);

//        axios.post('https://bridge.toxicfox.co.uk/api/groups/'+getCookie('current_group_uuid')+'/members/'+getCookie('current_member_uuid')+'/items', {
//          data: array,
//          headers: {
//            "Access-Control-Allow-Origin": "*"
//          }
//        })
//        .then(function (response) {
//          let data = response.data;
//          console.log(data);
//          //return false;
//          delete_cookie('current_group_uuid', getCookie('current_group_uuid'), 30);
//          delete_cookie('current_member_uuid', getCookie('current_member_uuid'), 30);
//        })
//        .catch(function (error) {
//          // handle error
//          console.log(error);
//        })
//        .then(function(){
//          window.location.href= 'https://toxicfox.co.uk/cart/clear';
//          //return false;
//        });

//      };

//    });

function apply_group(){
  //$('.page-header .cart-summary.global-border-radius').children().last().prepend('<button id="add_to_group_btn" onclick="push_to_group()" class="btn cart-submit" style="float: left;background-color: #d82c8f;">Add to Group Order</button>');
  
  //console.log(GetURLParameter('item_id'));
  if(GetURLParameter('item_id')){
    
    $('.update-buttons #update').hide();
    
    update_group_order_btn.show();
    
  }else{
    add_to_group.show();
  }
  
}

function drop_group(samepage){
  delete_cookie('current_group_uuid', getCookie('current_group_uuid'), 30);
  delete_cookie('current_member_uuid', getCookie('current_member_uuid'), 30);
  if(samepage){
    location.reload();
  }else{
    window.location.href= 'https://toxicfox.co.uk/pages/groups';
  }
}

function add_group_banner(id_admin, group_uuid){
  $('body').prepend(
    '<div id="group_header_banner">'+
    '<p>🤩 You\'re currently in a <a href="/pages/groups">group order,</a> to return to individual ordering <a href="#" onclick="drop_group(true)">Click Here</a></p>'+
    '</div>'
  );
  apply_group();
}

function find_current_group(uuid, muuid){
  axios.get('https://bridge.toxicfox.co.uk/api/groups/'+uuid+'/members/'+muuid, {
    headers: {
      "Access-Control-Allow-Origin": "*"
    }
  })
  .then(function (response) {
    let data = response.data;
    console.log(data);
    groupObj = data.group;
    let is_admin = data.is_admin;
    add_group_banner(is_admin, data.group.uuid);
  })
  .catch(function (error) {
    // handle error
    console.log(error);
    drop_group(true);
  })
  .then(function(){
    //window.location.href= 'https://toxicfox.co.uk/cart/clear';
    //return false;
  });


}

$(function(){

  if(getCookie('current_group_uuid')) {

    find_current_group(getCookie('current_group_uuid'), getCookie('current_member_uuid'));

    //apply_group();
    //capture_form();
  }
})